const downloadFile = (file: string) => {
    // Create a new link
    const anchor = document.createElement('a');
    anchor.href = file;
    anchor.download = '';

    // Append to the DOM
    document.body.appendChild(anchor);

    // Trigger `click` event
    anchor.click();

    // Remove element from DOM
    document.body.removeChild(anchor);
};

export default downloadFile;
